import store from '../storage'

import Generate from '@/components/#pages/curses/Generate'
import Info from '@/components/#pages/curses/pages/Info'
import Name from '@/components/#pages/curses/pages/Name'
import Content from '@/components/#pages/curses/pages/Content'
import Publish from '@/components/#pages/curses/pages/Publish'

import Generate2 from '@/components/#pages/curses/Generate2'
import Info2 from '@/components/#pages/curses/pages/Info2'
import Name2 from '@/components/#pages/curses/pages/Name2'
import Content2 from '@/components/#pages/curses/pages/Content2'
import Publish2 from '@/components/#pages/curses/pages/Publish2'

import CurseView from '@/components/#public/curse/CurseView'
import CurseContent from '@/components/#public/curse/CurseContent'
import PayCourse from '@/components/#public/curse/PayCourse'

import CursesHome from '@/components/#public/curse/CursesHome'
import CursesRecomendation from '@/components/#public/curse/CursesRecomendation'
import Students from '@/components/#pages/curses/Students'
export default [
    {
        path: '/curse/home',
        component: CursesHome,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/curses/recomendation',
        component: CursesRecomendation,
        beforeEnter(to, from, next) {
            if (store.getters.typeOrigin == 'student') {
                next()
                return
            }
            next('/profile')
        }
    },
    {
        path: '/curse/:id/students',
        component: Students,
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/curse/generate',
        component: Generate,
        meta: {
            requiresAuth: true
        },
        children: [{
                path: '/',
                component: Info
            },
            {
                path: ':id?/name',
                component: Name
            },
            {
                path: ':id?/content',
                component: Content
            },
            {
                path: ':id?/publish',
                component: Publish

            }
        ]
    },
    
    {
        path: '/curse/generateactive',
        component: Generate2,
        meta: {
            requiresAuth: true
        },
        children: [{
                path: '/',
                component: Info2
            },
            {
                path: ':id?/name',
                component: Name2
            },
            {
                path: ':id?/content',
                component: Content2
            },
            {
                path: ':id?/publish',
                component: Publish2

            }
        ]
    },

    {
        path: '/curse/content/:url_public',
        component: CurseContent
    },
    {
        path: '/curse/pay/:url_public',
        name: 'paymentCourse',
        component: PayCourse,
        props: { CourseInfo: false },
        meta: {
            requiresAuth: true
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/curse.js